// src/features/editor/components/blocks/QuizBlockEditor.tsx
// Router: dispatches to the per-subtype editor based on quizType.
import type { QuizBlock } from '@/types/blocks'
import { ChoiceQuizEditor } from './ChoiceQuizEditor'
import { YesNoQuizEditor } from './YesNoQuizEditor'
import { FillBlankQuizEditor } from './FillBlankQuizEditor'

interface Props {
  block: QuizBlock
  onChange: (next: QuizBlock) => void
}

// Секция картинки убрана по бэк-логу заказчика (п.21): её место займёт анимация
// маскота. Поля image/imagePrompt на блоке остаются — данные существующих курсов
// не трогаем, но задать промпт больше негде, и квиз выпадает из планов отрисовки.
export const QuizBlockEditor = ({ block, onChange }: Props) => {
  switch (block.quizType ?? 'choice') {
    case 'yes_no':
      return <YesNoQuizEditor block={block} onChange={onChange} />
    case 'fill_blank':
      return <FillBlankQuizEditor block={block} onChange={onChange} />
    default:
      return <ChoiceQuizEditor block={block} onChange={onChange} />
  }
}
